import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { DeliPriceService } from '../../../service/deli-price/deli-price.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { PrefService } from '../../../service/pref/pref.service';
import { SizeService } from '../../../service/size/size.service';
import { WeightService } from '../../../service/weight/weight.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9182',
  templateUrl: './wa9182.component.html',
  styleUrls: ['./wa9182.component.scss']
})
export class Wa9182Component implements OnInit, OnChanges {
  public owners: any;
  public carriers: any;
  public prefs: any;
  public sizes: any;
  public weights: any;

  public ownerId: number;
  public ownerTx: string;
  public delipriceId: number;
  public carrierCd: string;
  public notchargeFl: number;
  public prefCd: string;
  public sizeCd: string;
  public weightCd: string;
  public priceNr: number;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private deliPriceSelectOriginal = null;
  private isShowRemoveModal = false;

  private isUpdateButtonEnabled = false;
  private isCarrierClassActive = false;
  private isPrefCdClassActive = false;
  private isSizeCdClassActive = false;
  private isWeightCdClassActive = false;
  private isPriceNrClassActive = false;
  private isPriceNrClassError = false;
  private carrierCdClass;
  private prefCdClass;
  private sizeCdClass;
  private weightCdClass;

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private deliPriceService: DeliPriceService,
    private prefService: PrefService,
    private sizeService: SizeService,
    private weightService: WeightService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private carrierService: CarrierService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.owners = outputJson.owners;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.carrierService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.carriers = __outputJson.carriers;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.prefService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.prefs.push({ prefCd: '', prefTx: '選択しない' });
        this.prefs = __outputJson.prefs;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  changeCarrier() {
    console.log(this.carrierCd);
    this.isCarrierClassActive = this.carrierCd != this.deliPriceSelectOriginal['carrierCd'];
    this.checkUpdateButtonState();

    this.sizeService
      .get(this.carrierCd)
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.sizes.push({ carrierTx: '-', delisizeCd: '', delisizeTx: '選択しない' });
        this.sizes = __outputJson.sizes;
        this.sizeCd = '';
        this.isSizeCdClassActive = false;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.weightService
      .get(this.carrierCd)
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.weights.push({ carrierTx: '-', deliweightCd: '', deliweightTx: '選択しない' });
        this.weights = __outputJson.weights;
        this.weightCd = '';
        this.isWeightCdClassActive = false;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  changeWeight() {
    if (this.weightCd == 'X1') this.sizeCd = '';
  }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isUpdateButtonEnabled) return;

    if (Number(this.notchargeFl) === 1) {
      this.isShowRemoveModal = true;
      // this.dialogsService.confirm('注意', '対象[荷主+配送会社]で登録したその他の送料設定は削除されます。よろしいですか？').subscribe(res => {
      //   if (res === true) {
      //     this.prefCd = '-';
      //     this.sizeCd = '-';
      //     this.weightCd = '-';
      //     this.priceNr = 0;
      //     this.postDeliPrice();
      //   }
      // });
    } else {
      if (this.weightCd === 'X1' && this.sizeCd !== '') {
        this.errorInfo = 'サイズと重量を正しく選択してください';
        return;
      }
      if (this.priceNr < 0 || this.priceNr > 9999999) {
        this.errorInfo = '配送料は9999999より小さい数字で入力してください';
        return;
      }
      this.notchargeFl = 0;
      this.postDeliPrice();
    }
  }
  confirmOk() {
    this.isShowRemoveModal = false;
    this.prefCd = '-';
    this.sizeCd = '-';
    this.weightCd = '-';
    this.priceNr = 0;
    this.postDeliPrice();
  }

  postDeliPrice() {
    this.working = true;
    this.deliPriceService
      .put(
        this.ownerId,
        this.delipriceId,
        this.carrierCd,
        Number(this.notchargeFl),
        this.prefCd ? this.prefCd : '-',
        this.sizeCd ? this.sizeCd : '-',
        this.weightCd ? this.weightCd : '-',
        this.priceNr,
        'wa9182'
      )
      .then(outputJson => {
        sessionStorage.setItem('9182upd', 'ok');
        this.working = false;
        sessionStorage.removeItem('delipriceOneSelect');
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  cancel() {
    this.closeButtonClick.emit(false);
    sessionStorage.removeItem('delipriceOneSelect');
  }

  initDatas() {
    const delipriceSelect: object = JSON.parse(sessionStorage.getItem('delipriceOneSelect'));
    if (delipriceSelect['prefCd'] == null) delipriceSelect['prefCd'] = '';

    if (delipriceSelect['delisizeCd'] == null) delipriceSelect['delisizeCd'] = '';

    if (delipriceSelect['deliweightCd'] == null) delipriceSelect['deliweightCd'] = '';

    this.deliPriceSelectOriginal = delipriceSelect;

    this.ownerId = delipriceSelect['ownerId'];
    this.ownerTx = delipriceSelect['ownerTx'];
    this.delipriceId = delipriceSelect['delipriceId'];
    this.carrierCd = delipriceSelect['carrierCd'];
    this.notchargeFl = delipriceSelect['notchargeFl'];
    this.prefCd = delipriceSelect['prefCd'];
    this.sizeCd = delipriceSelect['delisizeCd'];
    this.weightCd = delipriceSelect['deliweightCd'];
    this.priceNr = delipriceSelect['deliunitpriceNr'];


    this.isUpdateButtonEnabled = false;
    this.isCarrierClassActive = false;
    this.isPrefCdClassActive = false;
    this.isSizeCdClassActive = false;
    this.isWeightCdClassActive = false;
    this.isPriceNrClassActive = false;
    this.isPriceNrClassError = false;

    this.sizeService
      .get(this.carrierCd)
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.sizes.push({ carrierTx: '-', delisizeCd: '', delisizeTx: '選択しない' });
        this.sizes = __outputJson.sizes;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.weightService
      .get(this.carrierCd)
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.weights.push({ carrierTx: '-', deliweightCd: '', deliweightTx: '選択しない' });
        this.weights = __outputJson.weights;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onRadioGroupChange() {
    this.errorInfo = '';

    this.checkUpdateButtonState();
  }

  checkUpdateButtonState() {
    this.isUpdateButtonEnabled =
      this.isCarrierClassActive ||
      this.isPrefCdClassActive ||
      this.isSizeCdClassActive ||
      this.isWeightCdClassActive ||
      this.isPriceNrClassActive ||
      this.notchargeFl != this.deliPriceSelectOriginal['notchargeFl'];
  }

  onPrefCdChanged() {
    this.isPrefCdClassActive = this.prefCd != this.deliPriceSelectOriginal['prefCd'];
    this.checkUpdateButtonState();
  }

  onSizeCdChanged() {
    this.isSizeCdClassActive = this.sizeCd != this.deliPriceSelectOriginal['delisizeCd'];
    this.checkUpdateButtonState();
  }

  onWeightCdChanged() {
    this.isWeightCdClassActive = this.weightCd != this.deliPriceSelectOriginal['deliweightCd'];
    this.checkUpdateButtonState();
  }

  priceNrClass() {
    return {
      active: this.isPriceNrClassActive,
      error: this.isPriceNrClassError
    };
  }

  onPriceNrInput(event) {
    this.errorInfo = '';

    this.priceNr = event.target.value;
    this.isPriceNrClassError = event.target.value === '';
    if (!this.isPriceNrClassError) this.isPriceNrClassActive = event.target.value !== this.deliPriceSelectOriginal['deliunitpriceNr'] + '';
    else this.isPriceNrClassActive = false;
    this.checkUpdateButtonState();
  }

  ngDoCheck() {
    if (this.isShow) {
      const delipriceSelect: object = JSON.parse(sessionStorage.getItem('delipriceOneSelect'));

      // this.ownerId = delipriceSelect['ownerId'];
      // this.ownerTx = delipriceSelect['ownerTx'];
      // this.delipriceId = delipriceSelect['delipriceId'];
      // this.carrierCd = delipriceSelect['carrierCd'];
      // this.notchargeFl = delipriceSelect['notchargeFl'];
      // this.prefCd = delipriceSelect['prefCd'];
      // this.sizeCd = delipriceSelect['delisizeCd'];
      // this.weightCd = delipriceSelect['deliweightCd'];
      // this.priceNr = delipriceSelect['deliunitpriceNr'];

      if (this.carrierCd !== delipriceSelect['carrierCd']) {
        this.carrierCdClass = "active";
      } else {
        this.carrierCdClass = "normal";
      }
      if (this.prefCd !== delipriceSelect['prefCd']) {
        if (this.prefCd != null && this.prefCd.length > 0)
          this.prefCdClass = 'active';
        else
          this.prefCdClass = 'normal';
      } else {
        this.prefCdClass = 'normal';
      }

      if (this.sizeCd !== delipriceSelect['delisizeCd']) {

        if (this.sizeCd != null && this.sizeCd.length > 0)
          this.sizeCdClass = 'active';
        else
          this.sizeCdClass = 'normal';
      } else {
        this.sizeCdClass = 'normal';
      }

      if (this.weightCd !== delipriceSelect['deliweightCd']) {
        if (this.weightCd != null && this.weightCd.length > 0)
          this.weightCdClass = 'active';
        else
          this.weightCdClass = 'normal';
      } else {
        this.weightCdClass = 'normal';
      }

      this.isUpdateButtonEnabled =
        this.carrierCdClass === 'active' ||
        this.prefCdClass === 'active' ||
        this.sizeCdClass === 'active' ||
        this.weightCdClass === 'active' ||
        this.isPriceNrClassActive ||
        this.notchargeFl != this.deliPriceSelectOriginal['notchargeFl'];
    }
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9182/wa9182.component.ts